export default function OperationsIcon({
  width = 16,
  height = 16,
  color = "#8E8C8F",
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8 0.833328C8 0.833328 7.44093 1.16699 7.29553 1.24399C7.00467 1.39811 6.58089 1.60823 6.05518 1.82871C5.00093 2.27085 3.55133 2.74847 1.95025 2.90719L1.5 2.95182V7.36546C1.5 10.0601 3.13303 12.0045 4.68633 13.2448C5.46782 13.8689 6.24668 14.3297 6.82913 14.6343C7.12093 14.787 8 15.1667 8 15.1667C8 15.1667 8.87907 14.787 9.17087 14.6343C9.75333 14.3297 10.5322 13.8689 11.3137 13.2448C12.8669 12.0045 14.5 10.0601 14.5 7.36546V2.95182L14.0497 2.90719C12.4487 2.74847 10.9991 2.27085 9.9448 1.82871C9.41913 1.60823 8.99533 1.39811 8.70447 1.24399C8.55907 1.16699 8 0.833328 8 0.833328ZM6.66667 7.66666C6.66667 6.93026 7.2636 6.33333 8 6.33333C8.7364 6.33333 9.33333 6.93026 9.33333 7.66666C9.33333 8.40299 8.7364 8.99999 8 8.99999C7.2636 8.99999 6.66667 8.40299 6.66667 7.66666ZM8 4.99999C6.52724 4.99999 5.33333 6.1939 5.33333 7.66666C5.33333 9.13939 6.52723 10.3333 8 10.3333C9.4728 10.3333 10.6667 9.13939 10.6667 7.66666C10.6667 6.1939 9.47273 4.99999 8 4.99999Z"
        fill={color}
      />
    </svg>
  );
}
